(function ($) {
  Drupal.behaviors.productFullDetailsV1 = {
    attached: false,
    attach: function (context) {
      var self = this;
      var $viewLink = $('.js-view-link', context);
      var $productInfo = $('.js-use-with-info', context);
      var skuBaseId = $productInfo.data('sku-base-id');
      var skuInventoryStatus = $productInfo.data('inventory-status');
      var $addToBag = $('.js-add-to-cart', $productInfo);
      var $atbLink = $('.js-use-with-atb-link', $productInfo);
      var $productPrice = $('.js-price', $productInfo);
      var $productUseWithActions = $('.js-use-with-actions', $productInfo);

      if (self.attached) {
        return;
      }
      self.attached = true;

      // updating atb with sku data to update cache
      $addToBag.data('sku-base-id', skuBaseId);
      $addToBag.data('product-id', $productInfo.data('product-id'));

      if ($addToBag.length > 0) {
        switch (skuInventoryStatus) {
          case 1:
            $addToBag.data('disabled', false);
            break;
          case 2:
            $('.js-inv-status-2', $productInfo).removeClass('hidden');
            $addToBag.data('disabled', false);
            break;
          case 3:
            $atbLink.hide();
            $('.js-inv-status-3', $productInfo).removeClass('hidden');
            $productUseWithActions.addClass('atb-hidden');
            break;
          case 5:
            $atbLink.hide();
            $('.js-inv-status-5', $productInfo).removeClass('hidden');
            $productUseWithActions.addClass('atb-hidden');
            break;
          case 7:
            $atbLink.hide();
            $('.js-inv-status-7', $productInfo).removeClass('hidden');
            $productUseWithActions.addClass('atb-hidden');
            break;
        }
      }

      $('.js-use-with-atb-link').once().on('click', function(e) {
        e.preventDefault();
        $addToBag.trigger('click');
      });

      $viewLink.once().on('click keydown', function (e) {
        if (e.key === 'Enter' || e.type === 'click') {
          var $detailsSection = $(this).parents('.js-details-section');
          var $truncatedContent = $('.js-details-heading-snippet', $detailsSection);
          var $content = $('.js-details-content', $detailsSection);
          var isExpanded = $detailsSection.attr('aria-expanded') === 'true' ? true : false;

          $truncatedContent.add($content).toggleClass('hidden');
          $content.attr('aria-hidden', isExpanded);
          $detailsSection.attr('aria-expanded', !isExpanded);
          $content.toggleClass('expanded');
          $('.js-view-less', $content).toggleClass('hidden');
        }
      });
      $productPrice.once().on('click', function() {
        if (!$(this).hasClass('atb-hidden')) {
          $addToBag.trigger('click');
        }
      });
      $productUseWithActions.once().on('keydown', function(e) {
        if(e.key === "Enter") {
          $addToBag.trigger('click');
        }
      });
    }
  };
})(jQuery);
